import { render, staticRenderFns } from "./editDialogShow.vue?vue&type=template&id=1450f220&scoped=true&"
import script from "./editDialogShow.vue?vue&type=script&lang=js&"
export * from "./editDialogShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1450f220",
  null
  
)

export default component.exports